<template>
  <div class="row mx-0 px-0 col-md-12 py-2">
    <template v-for="(event_item, evtIdx) in items" :key="evtIdx">
      <div
        class="col-md-6 col-12 wow bounceInUp mb-4"
        @click="onEventClick(event_item)"
      >
        <div
          v-bind:title="event_item.EventName"
          :class="[
            'card bg-light-grey',
            store.state.selected_event.EventCampaignId == event_item.EventCampaignId ? 'card_selected' : ''
          ]"
        >
          <span
            v-show="store.state.selected_event.EventCampaignId != event_item.EventCampaignId"
            class="pt-1 success_hv far fa-check-circle"
          ></span>
          <span
            v-show="store.state.selected_event.EventCampaignId == event_item.EventCampaignId"
            class="pt-1 remove_item_card far fa-times-circle"
          ></span>
          <div class="bg-light-grey py-0">
            <h5 class="align-middle py-2 my-0">
              {{ event_item.EventName }}
            </h5>
          </div>
          <div class="light bg-light-grey">
            <div class="table">
              <div class="align-top">
                <img
                  class="card-img-top px-2"
                  :class="{ 'obj-cover': listIdentifier === 'internalEvents' }"
                  :src="useImagePlugin().getImageWithResolution(event_item.EventImagePath, 1000)"
                  alt="Card image cap"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import store from '../../store/store'
import useImagePlugin from '../../composables/useImagePlugin'

export default {
  name: 'EventList',
  props: {
    items: {
      type: Array,
    },
    listIdentifier: '',
  },
  data() {
    return {
      store,
      useImagePlugin,
    }
  },
  methods: {
    stage(eventCampaignId, eventName, eventImagePath, eventUrl) {
      this.$.appContext.config.globalProperties.emitter.emit(
        'stageEvent', 
        {
          eventCampaignId, eventCampaignId,
          eventName: eventName,
          eventImagePath: eventImagePath,
          eventUrl: eventUrl,
          listIdentifier: this.listIdentifier
        }
      )
    },

    removeEventCampaignId() {
      this.$.appContext.config.globalProperties.emitter.emit('clearEvent')
    },

    onEventClick(event_item) {
      return this.store.state.selected_event.EventCampaignId != event_item.EventCampaignId
        ? this.stage(
              event_item.EventCampaignId,
              event_item.EventName,
              event_item.EventImagePath,
              event_item.EventUrl
          )
        : this.removeEventCampaignId()
    }
  }
}
</script>

<style scoped>
.card-img-top {
  height: 120px;
  object-fit: contain;
}

.obj-cover {
  object-fit: cover !important;
}

h5 {
  color: rgb(0, 0, 0);
}
</style>
